export const CONTAINER_MODEL = {
  aditionalClass: "section-main section-main__internal section-main__internal-no-cliente"
};

export const DETAILS_MODEL = {
  client: false,
  nameLink: "Volver a Consultar",
  urlLink: "/consulta-soat",
  titlerimac: "<h1>¡Lo sentimos!</h1><p>No hemos logrado encontrar infomación de la placa ingresada: [placa]. </p>",
  titleClass: "internal-title"
};

export const CARD_DETAILS = {
  imagenCard: "/consulta-soat/assets/icons/icon_soat.svg",
  afterText: "Desde <span>S/39 al año</span>",
  title: "Adquiere tu SOAT <span>RIMAC</span>",
  oneStep: true,
  marking: "Comprar SOAT",
  link: "[URL]/comprar/soat-digital?pcid=publica:consulta-soat:no-clientes:resultado:sin-resultado",
  titleButton: "Comprar SOAT",
  client: false,
};

export const FOOTER_MODEL = {
  altFooter: "Logo Footer",
  address: "Calle Las Begonias 650 Piso 10, San Isidro.",
  txtFooter: "© [year] RIMAC Seguros y Reaseguros."
};